import React from 'react'
import { connect } from 'react-redux'
import { t } from 'ttag'

import Field from '../../components/form/Field'
import ActionButton from '../../components/ActionButton'
import { receivedResponse } from '../../h2Api'
import Form from '../../components/form/Form'
import { requestReferral } from '../../actions/educatorAccountReferralActions'
import { required } from '../../components/form/validations'
import * as v from '../../components/form/validations.js'

class EducatorReferral extends React.Component {
  render = () => {
    return (
      <div className="container">
        <div className="col-sm-6">
          <h3 className="section-heading">{t`Get more users, FREE!`}</h3>
          <p>
            {t`If you know someone who could benefit from a free educator account on the
                    ${dynamicValues.systemName}, use the form opposite to refer them.`}
          </p>
          <p>{t`For every successful signup, you'll get 10 extra users added to your quota up to 50.`}</p>
        </div>
        <div className="col-sm-6">
          <div className="text-center">
            <img
              src="/images/headed2/new/share/Share_img.svg"
              alt={t`Image of present box`}
            />
          </div>
          <Form
            model={'educatorReferral.educatorReferralForm'}
            validate={{
              email: [required('email'), v.targetField('email', v.email())]
            }}
            onSubmit={acctRequest => this.props.dispatch(requestReferral(acctRequest))}>
            {form => (
              <div style={{ border: '4px solid #000', padding: '15px' }}>
                <div
                  className="instructions"
                  style={{
                    marginBottom: '25px'
                  }}>
                  {t`Enter the requested information in the form below.`}
                </div>
                <Field
                  model={`educatorReferral.educatorReferralForm.name`}
                  form={form}
                  largeTextInput={true}
                  label={t`Name`}
                  required={true}>
                </Field>
                <Field
                  model={`educatorReferral.educatorReferralForm.email`}
                  form={form}
                  largeTextInput={true}
                  label={t`Email`}
                  required={true}>
                </Field>
                {/*
                            <Field model={`educatorReferral.educatorReferralForm.message`}
                                   form={form}
                                   type="textarea"
                                   label={ t`Comments`}
                                   className="form-control"
                                   required={false}>

                            </Field>
                                */}
                <ActionButton
                  loading={this.props.request.loading}
                  error={this.props.request.error}
                  success={
                    receivedResponse(this.props.request) && t`Your Referral Has Been Sent`
                  }
                  className="btn btn-success btn-full"
                  type="submit">
                  {t`Refer Educator`}
                </ActionButton>
              </div>
            )}
          </Form>
        </div>
      </div>
    )
  }
}

export default connect(
  state => {
    return {
      ...state,
      dynamicValues,
      userProfile: state.authenticationState.userProfile,
      request: state.educatorReferral.requestDetail
    }
  },
  dispatch => ({
    dispatch
  })
)(EducatorReferral)
